import { defineSemanticTokens } from '@chakra-ui/react';

/**
 * Три ступени скругления, которыми Chakra рисует все рецепты: l3 — поверхности
 * (диалоги, поповеры, карточки), l2 — контролы (кнопки, поля, теги, тултипы),
 * l1 — строки внутри контролов (пункты меню, галочки, чипы-образцы).
 *
 * Дефолты Chakra (2/4/6px) были заметно острее наших собственных поверхностей на
 * 12px: кнопка на 4px внутри карточки на 12px читалась как деталь из другой системы,
 * а диалог на 6px выглядел настолько чужим, что радиус переопределяли руками —
 * отсюда и разъехавшиеся 16px / 22px / 28px по экранам.
 *
 * Шкала теперь одна: 12 — поверхность, 8 — всё, что лежит на ней, full — пилюли.
 */
export const radii = defineSemanticTokens.radii({
  l1: {
    value: '{radii.sm}',
  },
  l2: {
    value: '{radii.lg}',
  },
  l3: {
    value: '{radii.xl}',
  },
});
